import React from 'react';
import { FormattedMessage } from 'react-intl';

import Typography from 'carbon-react/lib/components/typography';

import { Sidebar } from '@futrli/ui-components';
import { useSidebarResetCounter } from '@futrli/predict/hooks/useSidebarResetCounter/useSidebarResetCounter';

import { DuplicateForecastContainer } from './containers/duplicate-forecast-container';
import { DuplicateForecastContextProvider } from './context/duplicate-forecast-context';

interface DuplicateForecastSidebarProps {
  forecastId?: string;
  isOpen: boolean;
  onClose: () => void;
}

export const DuplicateForecastSidebar = ({ forecastId, isOpen, onClose }: DuplicateForecastSidebarProps) => {
  const { resetKey } = useSidebarResetCounter(isOpen);

  if (!forecastId) {
    return null;
  }

  return (
    <Sidebar
      header={
        <>
          <Typography variant="h2" fontWeight="700">
            <FormattedMessage id="predict.forecasting.duplicate" defaultMessage="Duplicate" />
          </Typography>
        </>
      }
      onCancel={onClose}
      open={isOpen}
    >
      <DuplicateForecastContextProvider key={resetKey} forecastId={forecastId}>
        <DuplicateForecastContainer onClose={onClose} />
      </DuplicateForecastContextProvider>
    </Sidebar>
  );
};
